import { Component, ChangeDetectorRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ioteqMediaWatcherService } from '@tools/services/media-watcher';
import { ioteqNavigationService, ioteqVerticalNavigationComponent } from '@tools/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { AuthService } from "../../../../core/auth/auth.service";
import { UserService} from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';

import { MapListSliderService } from '@tools/components/map-list-slider/map-list-slider.service';
import { tr } from 'date-fns/locale';

import { AngularFirestore } from '@angular/fire/compat/firestore';


@Component({
    selector     : 'material-layout',
    templateUrl  : './material.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class MaterialLayoutComponent implements OnInit, OnDestroy
{
    isScreenSmall: boolean;
    navigation: Navigation;
    user: User;
    orgTitle: any = { name: "" }

    innerCheck: boolean;
    checkSub: Subscription;
    observe$: Observable<boolean>;

    checked: boolean
    disabled: boolean
    send: string

    checkSubscription: Subscription
    disabledSubscription: Subscription
    sendSubscription: Subscription


    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _ioteqMediaWatcherService: ioteqMediaWatcherService,
        private _ioteqNavigationService: ioteqNavigationService,
        private authService: AuthService,
        private _userService: UserService,
        private _changeDetectorRef: ChangeDetectorRef,
        private angularFirestore: AngularFirestore,
        public data: MapListSliderService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
                //console.log(this.user)

                if(!this.user){
                    const user = JSON.parse(sessionStorage.getItem('user'));
                    //console.log(user)

                    if (user){
                        this.user = user
                    }
                    
                }

                if(this.user.organization !== 'profrac' && this.user.organization !== 'f' && this.user.organization !== 'ioteq'){
                    
                    const orgRef = this.angularFirestore.firestore.collection('organizations')
                    //const orgRef = collection(this.angularFirestore, 'organizations')
        
                    orgRef.get().then(snapshot => {
                        snapshot.forEach(doc => {
                            let org = doc.data()
                            if (this.user.organization === org['name']){
                                this.orgTitle.name = org['title']
                            }
                        })
                    })
                }

                // Mark for check
                this._changeDetectorRef.detectChanges();
            },error=>{
            });

        if(!this.user){
            const user = JSON.parse(sessionStorage.getItem('user'));
            //console.log(user)
            if (user){
                this.user = user
            }
        }

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
                //console.log(navigation)
            });

        // Subscribe to media changes
        this._ioteqMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        // Subscribe to menu
        this.authService.sidenavMenu.subscribe((menu) => {
            if(menu){
                //console.log(menu)
                this._navigationService.getNavigation(menu)
            }
        });       

        this.checkSubscription = this.data.checkedServiceVal.subscribe(res => {
            this.checked = res
            //console.log('pl', this.checked)
        })

        this.disabledSubscription = this.data.disabledServiceVal.subscribe(res => {
            this.disabled = res
        })

        this.sendSubscription = this.data.sendServiceVal.subscribe(res => {
            this.send = res
            //console.log(this.send)
        })
        
        if (localStorage.getItem("check")){
            if (localStorage.getItem("check") === "true"){
                this.checked = true
            }
            else if (localStorage.getItem("check") === "false"){
                this.checked = false
            }
            //console.log(localStorage.getItem("check"), this.checked)
        }
        
        if (localStorage.getItem("send")){
            if (localStorage.getItem("send") === "map"){
                this.send = 'map'
            }
            else if (localStorage.getItem("send") === "list"){
                this.send = 'list'
            }
            //console.log(localStorage.getItem("send"), this.send)
        }

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._ioteqNavigationService.getComponent<ioteqVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
